import deleteAsset from '../base-saving-actions/delete-asset';

const deleteAssets = (assetSourcesToDelete) =>
  assetSourcesToDelete.map((source) => deleteAsset(source));

export default deleteAssets;
